import { EpocusPerformerCredentialStatus } from "elephant-web/gql";
import type { PillTone } from "../../_lib/admin-primitives";

const STATUS_PRESENTATION: Record<
  EpocusPerformerCredentialStatus,
  { label: string; tone: PillTone }
> = {
  [EpocusPerformerCredentialStatus.Credentialed]: {
    label: "Credentialed",
    tone: "ok",
  },
  [EpocusPerformerCredentialStatus.InProgress]: {
    label: "In progress",
    tone: "warn",
  },
  [EpocusPerformerCredentialStatus.Provisional]: {
    label: "Provisional",
    tone: "info",
  },
};

export const credentialStatusLabel = (
  status: EpocusPerformerCredentialStatus,
): string => STATUS_PRESENTATION[status].label;

export const credentialStatusTone = (
  status: EpocusPerformerCredentialStatus,
): PillTone => STATUS_PRESENTATION[status].tone;

export const CREDENTIAL_STATUS_OPTIONS = [
  EpocusPerformerCredentialStatus.Provisional,
  EpocusPerformerCredentialStatus.InProgress,
  EpocusPerformerCredentialStatus.Credentialed,
] as const;
